import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useParams, useLocation } from "react-router-dom"

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Graphic from '../../images/graphic.png';

import { Flex } from '../../utils/Common'

import { Signin as Login, Setup, ChangePass } from '../../components/login'

// auth hook
import useAuth from '../../hooks/useAuth';

const Container = styled(Flex)`
  background-color: ${props => props.theme.colors.body};
  height: 100vh;
`

const LoginContainer = styled(Flex)`
 width: 45%;
 padding: 0 8rem;

 @media ${props => props.theme.breaks.down('md')} {
  width: 100%;
  padding: 1.5rem;
 }
`

const GraphicContainer = styled(Flex)`
  /* background-color: orange; */
  width: 50%;
`

const Image = styled.div`
width: 100%;
  img {
    display: block;
    margin: 0 auto;
    width: 60%;
  }
`

const Description = styled.div`
  max-width: 65rem;
  color: ${props => props.theme.colors.lightText};
  margin-top: 5rem;
  line-height: 2.2rem;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 500;
`


const Signin = () => {
  const theme = useTheme();
  // This will help us to determine if the screen size is small or not
  const isNotMobile = useMediaQuery(theme.breakpoints.up('md'));

  const params = useParams()
  const location = useLocation()
  const pathname = location.pathname
  const path = pathname.split("/")[1];
  // const queries = Object.fromEntries([...params])

  // console.log(location)

  const { login, isLoggingIn } = useAuth()

  const handleSubmit = async (info, formikHelpers) => {
    await login({ 
      userData: info, 
      formikHelpers 
    })
  }

  let loginComponent;

  if (path === 'setup-account') {
    loginComponent = <Setup handleSubmit={handleSubmit} />
  } else {
    loginComponent = <Login isLoading={isLoggingIn} handleSubmit={handleSubmit} />

  }

  return (
  <Container dir="row">
    <LoginContainer justify="center" align="center">
      {loginComponent}
    </LoginContainer>

   {isNotMobile ? <GraphicContainer justify="center">
          <Image>
            <img src={Graphic} alt="salon graphic" />
          </Image>
        <Description>
        Transform your salon experience with NOVOSALON PRO. Our intuitive platform helps stylists and salon owners effortlessly manage appointments, track client preferences, and process payments—all in one place. Spend less time on paperwork and more time creating beautiful experiences while watching your business grow.
        </Description>
    </GraphicContainer> : null }
  </Container>
)}

export default Signin;